import { SET_CONTEXT } from '../actions/type';

const initState = {
    p: '',
    name: '',
    pkgcode: '',
    email: '',
    avatar: ''
}

const contextInfo = (state = initState, action) => {
    switch (action.type) {
        case SET_CONTEXT:
            const { payload } = action
            return payload
        default:
            return state;
    }
}

export default contextInfo